import _ from 'lodash';

const root = state => _.get(state, 'routing');

export const getLocation = state => _.get(root(state), 'location');

export const getPathname = state => _.get(getLocation(state), 'pathname');

export const getSearchParams = state => _.get(getLocation(state), 'search');

export const getIsOnPointOfSale = state =>
  getPathname(state).match(/\/pointofsale/g);

export const getIsOnLogin = state => getPathname(state) === '/';



// WEBPACK FOOTER //
// ./src/common/Selectors/RoutingSelector.js